"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextContainer = exports.Text = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Utils = require("../Utils");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const Container = exports.Container = (0, _styledComponents.default)(_Utils.Button).withConfig({
  shouldForwardProp: prop => !['radio'].includes(prop)
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    align-items: center;\n    ", "\n    border: 1px ", ";\n    border-color: ", ";\n    ", "\n    ", "\n    display: inline-flex;\n    height: ", "px;\n    justify-content: center;\n    margin-right: 5px;\n    ", "\n    width: ", "px;\n\n    @media print {\n        display: inline-flex !important;\n    }\n"])), _ref => {
  let {
    checked,
    disabled,
    theme: {
      disabledColor,
      primaryColor
    }
  } = _ref;
  return checked ? "background-color: ".concat(disabled ? disabledColor : primaryColor, ";") : 'background-color: #FFFFFF;';
}, _ref2 => {
  let {
    checked
  } = _ref2;
  return !checked ? 'dashed' : 'solid';
}, _ref3 => {
  let {
    color,
    disabled,
    theme: {
      disabledColor,
      primaryColor
    }
  } = _ref3;
  return color ? color : disabled ? disabledColor : primaryColor;
}, (0, _Utils.ifProp)('radio', 'border-radius: 100%;'), (0, _Utils.ifProp)('disabled', '', 'cursor: pointer;'), _ref4 => {
  let {
    size
  } = _ref4;
  return size;
}, _ref5 => {
  let {
    margin
  } = _ref5;
  return !!margin ? "margin: ".concat(margin, ";") : '';
}, _ref6 => {
  let {
    size
  } = _ref6;
  return size;
});
const Text = exports.Text = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n"])), _ref7 => {
  let {
    color,
    disabled,
    theme: {
      disabledColor,
      primaryColor
    }
  } = _ref7;
  return color ? color : disabled ? disabledColor : primaryColor;
}, (0, _Utils.getProp)('fontSize'));
const TextContainer = exports.TextContainer = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    ", "\n"])), _ref8 => {
  let {
    margin
  } = _ref8;
  return !!margin ? "margin: ".concat(margin, ";") : '';
});